// extracted by mini-css-extract-plugin
export var footerLogo = "footer-module--footer-logo--1bb6b";
export var footerMenu = "footer-module--footer-menu--7cdec";
export var ionSocialCodepen = "footer-module--ion-social-codepen--e21bd";
export var ionSocialGithub = "footer-module--ion-social-github--43ed9";
export var ionSocialInstagram = "footer-module--ion-social-instagram--b9b5e";
export var socialIcon = "footer-module--social-icon--e3c3c";